import { Box, Typography } from "@mui/material";

export function Date({ data }) {
  return (
    <Box>
      <Typography variant="subtitle1" component="p" color="text.secondary">
        {data.date}
      </Typography>

      <Typography variant="subtitle1" component="p" color="text.secondary">
        {data.time}
      </Typography>
    </Box>
  );
}

export default Date;
